import { Inject, Injectable } from '@angular/core'
import { Router, UrlTree } from '@angular/router'
import { Observable } from 'rxjs'
import { AuthContextStorageService } from '../auth-context-storage.service'
import { AuthService } from '../auth.service'

/**
 * AuthGuard - Checks if user is authenticated
 *
 * Applied to root protected route to ensure user is logged in.
 * If not authenticated, redirects to /login.
 */
@Injectable({ providedIn: 'root' })
export class AuthGuard  {

    constructor(
        @Inject(AuthContextStorageService) private authContext: AuthContextStorageService,
        @Inject(AuthService) private authService: AuthService,
        @Inject(Router) private router: Router
    ) {}

    canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

        if (this.authContext.isAuthenticated()) {
            return true
        }

        return this.authService.onStartup()
            .then(() => {
                if (this.authContext.isAuthenticated()) {
                    return true
                }
                return this.router.parseUrl('/login')
            })
            .catch(() => {
                return this.router.parseUrl('/login')
            })
    }
}